<template>
  <div class="row">
    <w-input class="col-md-6" :model="schema.$gte" @input="$emit('update')" />

    <w-input class="col-md-6" :model="schema.$lte" @input="$emit('update')" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz przedziału liczb
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>
